var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-/-dark-/-click-in,-typing",
    transform: "translate(-370.000000, -17.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-/-large-/-click-in,-typing",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(370.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,12 L1.33333333,12 L1.33333333,4.66666667 L10.6666667,4.66666667 M8.66666667,-3.64153152e-14 L8.66666667,1.33333333 L3.33333333,1.33333333 L3.33333333,-3.64153152e-14 L2,-3.64153152e-14 L2,1.33333333 L1.33333333,1.33333333 C0.593333333,1.33333333 0,1.92666667 0,2.66666667 L0,12 C0,12.7363797 0.596953667,13.3333333 1.33333333,13.3333333 L10.6666667,13.3333333 C11.4030463,13.3333333 12,12.7363797 12,12 L12,2.66666667 C12,1.92666667 11.4,1.33333333 10.6666667,1.33333333 L10,1.33333333 L10,-3.64153152e-14 M9.33333333,7.33333333 L6,7.33333333 L6,10.6666667 L9.33333333,10.6666667 L9.33333333,7.33333333 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c4bb2fed6836fd22235c020baf5de70d.svg";
export { ForwardRef as ReactComponent };